import React from "react";
import RightHandSide from "../../Common/Services/RightHandSide";
import AboutInnBanContent from "../../Common/InnerBanner/AboutInnBanContent";
import { AboutInnerBanner } from "../../Common/InnerBanner/AboutInnerBanner";
import HeadContent from "../BlogContent/HeadContent";
import HeadDesign from "../BlogContent/HeadDesign";
import Info from "../BlogContent/Info";
import List from "../BlogContent/List";
import InfoContent from "../BlogContent/InfoContent";
import ListContent from "../BlogContent/ListContent";
import RecentBlogsList from "../BlogContent/RecentBlogsList";
import { Helmet } from "react-helmet";

const Blog31 = () => {
  const { image, heading, pageName } = AboutInnBanContent.BlogDetails;
  const { bg, para, date, blogHeading } = HeadContent.blog_31;

  const { title, p } = InfoContent.Blog_31.one;
  const { title2, p2, p2a, p2b, p2c } = InfoContent.Blog_31.two;
  const { title3, p3, p3a } = InfoContent.Blog_31.three;
  const { title4, p4, p4a } = InfoContent.Blog_31.four;
  const { title5, p5 } = InfoContent.Blog_31.five;
  const { title6, p6 } = InfoContent.Blog_31.six;
  const { Ctitle, Cp } = InfoContent.Blog_31.conclusion;
  const { title7, p7 } = InfoContent.Blog_31.seven;

  const { liss1 } = ListContent.Blog_31.L1;
  const { liss2, liss2a, liss2b } = ListContent.Blog_31.L2;
  const { liss3 } = ListContent.Blog_31.L3;
  const { liss4 } = ListContent.Blog_31.L4;
  const { liss5 } = ListContent.Blog_31.L5;

  return (
    <>
      <Helmet>
        <title>Myths and Facts About Infertility Treatment (2026 Guide)</title>

        <meta
          name="description"
          content="Myths and facts about infertility treatment, explained by experts. Learn what's true, what's not, and find the best infertility specialist in Mumbai."
        />

        <meta
          name="keywords"
          content="Myths and Facts About Infertility Treatment, Best Infertility Specialist in Mumbai, IVF myths and facts, infertility treatment myths, infertility specialist Mumbai, IVF success rate myths, male infertility myths, infertility treatment cost India, fertility treatment misconceptions, IVF vs IUI myths"
        />

        <link
          rel="canonical"
          href="https://www.acmefertility.com/20/BlogDetails"
        />

        {/* Article Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            headline:
              "Fertility Clinic Near Me: IVF, IUI, ICSI & Other Treatment Options Explained",
            description:
              "Complete guide to IVF, IUI, ICSI and fertility treatments available at Acme Hospital.",
            author: {
              "@type": "Organization",
              name: "Acme Hospital",
            },
            publisher: {
              "@type": "Organization",
              name: "Acme Hospital",
            },
            mainEntityOfPage: {
              "@type": "WebPage",
            },
          })}
        </script>

        {/* Author Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Acme Hospital",
            description:
              "Trusted fertility hospital offering IVF, IUI, ICSI and advanced reproductive care.",
          })}
        </script>

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the difference between IVF and IUI?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "IVF fertilizes eggs outside the body, while IUI places prepared sperm directly into the uterus.",
                },
              },
              {
                "@type": "Question",
                name: "Who needs ICSI treatment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "ICSI is recommended mainly for severe male infertility or previous IVF fertilization failure.",
                },
              },
              {
                "@type": "Question",
                name: "When should I visit a fertility clinic?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Couples under 35 should seek help after one year of trying, while those over 35 should consult after six months.",
                },
              },
              {
                "@type": "Question",
                name: "How do I choose the best fertility clinic near me?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Look for experienced specialists, advanced laboratories, transparent pricing, ethical practices, and positive patient reviews.",
                },
              },
              {
                "@type": "Question",
                name: "Does Acme Hospital provide complete fertility care?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes. Acme Hospital offers fertility evaluation, IVF, IUI, ICSI, fertility preservation, counseling, and pregnancy support.",
                },
              },
            ],
          })}
        </script>
      </Helmet>

      <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

      <div className="blog-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <HeadDesign
                bg={bg}
                para={para}
                date={date}
                blogHeading={blogHeading}
              />
              <Info title={title} p={p} />
              <List liss={liss1} />
              <Info title={title2} p={p2} />
              <List liss={liss2} />
              <Info p={p2a} />
              <List liss={liss2a} />
              <Info p={p2b} />
              <List liss={liss2b} />
              <Info p={p2c} />
              <Info title={title3} p={p3} />
              <List liss={liss3} />
              <Info p={p3a} />
              <Info title={title4} p={p4} />
              <List liss={liss4} />
              <Info p={p4a} />
              <Info title={title5} p={p5} />
              <List liss={liss5} />
              <Info title={title6} p={p6} />
              <Info title={Ctitle} p={Cp} />
              <Info title={title7} p={p7} />

              {/* 
             
              <Info title={title3} p={p3} />
              <List liss={liss3} />
              
              <Info title={title5} p={p5} />
              <List liss={liss5} />
              <Info title={title6} p={p6} />
              <Info title={title7} p={p7} />
               */}
            </div>

            <div className="col-lg-4">
              <RecentBlogsList />
              <RightHandSide />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog31;
